import * as ep from "../../endpoints";
import api from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Vue from "vue";
export default {
  namespaced: true,
  state: {
    loading: false,
    loadingNextBeneficiarys: false,
    id: "",
    count_waiting: "",
    nomberOffice: "",
    service: "",
    visitor_id: "",
    available: false,
  },
  getters: {
    available(state) {
      return state.available;
    },
    loading(state) {
      return state.loading;
    },
    nomberOffice(state) {
      return state.nomberOffice;
    },
    loadingNextBeneficiarys(state) {
      return state.loadingNextBeneficiarys;
    },
    id(state) {
      return state.id;
    },
    count_waiting(state) {
      return state.count_waiting;
    },
    service(state) {
      return state.service;
    },
    visitor_id(state) {
      return state.visitor_id;
    },
  },
  mutations: {},
  actions: {
    async getDataOffice(context) {
      context.state.loading = true;
      await api.get(ep.OFFICE_BY_USER).then((res) => {
        context.state.id = res.data.data.id;
        context.state.nomberOffice = res.data.data.office_no;
        context.state.loading = false;
        context.dispatch("checkStatus")
      });
    },

    async checkStatus(context) {
      await api.get(ep.CHECK_STATUS(context.state.id)).then((res) => {
        context.state.available = res.data.data.is_available;
      });
    },

    async changeStatus(context, payloade) {
      context.state.loading = true;
      await api
        .get(ep.CHANGE_STATUS(context.state.id), {
          params: { is_available: !context.state.available },
        })
        .then((res) => {
          context.state.loading = false;
          context.state.available = !context.state.available;
        });
    },

    async nextBeneficiarys(context, payloade) {
      context.state.loadingNextBeneficiarys = true;
      await api.get(ep.NEXT_VISITOR(payloade.id)).then((res) => {
        context.state.loadingNextBeneficiarys = false;
        context.state.count_waiting = res.data.data.count_waiting;
        context.state.service = res.data.data.service ? res.data.data.service.title : "";
        context.state.visitor_id = res.data.data.visitor_id;
        Vue.$toast({
          component: ToastificationContent,
          props: {
            title: res.data.message,
            icon: res.data.status ? "CheckIcon": "XIcon",
            variant: res.data.status ? "success" : "danger",
          },
        });
        context.dispatch("checkStatus")
      });
    },

    availableChange(context, payloade) {
      context.state.available = payloade;
    },

    emptyDataOffice(context){
      context.state.service="";
      context.state.visitor_id="";
    },
  },
};
